import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sites-view',
  templateUrl: './sites-view.component.html',
  styleUrls: ['./sites-view.component.scss'],
})
export class SitesViewComponent implements OnInit {
  items: any;
  isListViewSelected: any = false;

  constructor(
    public dialogRef: MatDialogRef<SitesViewComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    this.items = this.data;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  closeDialogByChildSqaureView($event: any) {
    if ($event == true) this.dialogRef.close();
  }
  setListView(value: any) {
    this.isListViewSelected = value;
  }
}
